import type { LiveRankingType } from '../../apis/client-side/live/type';
import { ContextualError } from '../../utils/error/context-error';

type filterLinkMap = {
  sortBy: 'popular' | 'live' | 'month';
  searchType: LiveRankingType;
};

export const getRankingFilterList = (searchType: LiveRankingType): filterLinkMap[] => {
  if (searchType === 'rankingPersonalBJ' || searchType === 'LiveRankingPersonalBJ') {
    return [
      { sortBy: 'popular', searchType: 'rankingPersonalBJ' },
      { sortBy: 'live', searchType: 'LiveRankingPersonalBJ' },
    ];
  }
  if (searchType === 'rankingNewBJ' || searchType === 'LiveRankingNewBJ') {
    return [
      { sortBy: 'popular', searchType: 'rankingNewBJ' },
      { sortBy: 'live', searchType: 'LiveRankingNewBJ' },
    ];
  }
  if (searchType === 'rankingCrewBJ' || searchType === 'LiveRankingCrewBJ') {
    return [
      { sortBy: 'popular', searchType: 'rankingCrewBJ' },
      { sortBy: 'live', searchType: 'LiveRankingCrewBJ' },
    ];
  }
  if (searchType === 'rankingPopular' || searchType === 'rankingList' || searchType === 'rankingPopularMonth') {
    return [
      { sortBy: 'popular', searchType: 'rankingPopular' },
      { sortBy: 'live', searchType: 'rankingList' },
      { sortBy: 'month', searchType: 'rankingPopularMonth' },
    ];
  }

  throw new ContextualError(`Invalid searchType${searchType}`);
};

export const RankingTypeSortedByLive: LiveRankingType[] = [
  'LiveRankingPersonalBJ',
  'LiveRankingNewBJ',
  'LiveRankingCrewBJ',
  'rankingList',
];

export const showRankChangeRankingType: LiveRankingType[] = [
  'rankingPopular',
  'rankingPopularMonth',
  'rankingPersonalBJ',
  'rankingNewBJ',
  'rankingCrewBJ',
];
